import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import config from "../config/config";

export default function CheckForQueue(props) {

    const { instanceId } = useParams();

    const [iframeStyles, setIframeStyles] = useState({display:"none", width: "0px", height: "0px"});
    const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/ChooseSeats.aspx?EventInstanceId=${instanceId}`;

    useEffect(() => {
        const onMessage = (event) => {
            if (event.data?.show_book_online) {
                props.setCheckedForQueue(true);
            }
            
            if (event.data?.show_queue_iframe) {
                setIframeStyles({display: "block", width: "100%", height: "90vh"});
            }            
        };

        window.addEventListener("message", onMessage);
        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);


    return (
        <div className="booking-pathway__queue-check">
            <iframe
                className="spektrix-iframe"
                name="SpektrixIFrame"
                id="SpektrixIFrame"
                src={iframeURL}
                title="Queue"
                style={iframeStyles}
                allow="local-network-access"
            />
        </div>
    );
}
